/*
    Available methods:
    site(): return the site path
    prop(propName): return the corresonponding property. propName can be 'market' or 'language'
*/
define('shared/util/path',[
    'shared/lib/ctor',
    'shared/lib/RSVP',
    './path/ResolverFactory'
], function (
    ctor,
    RSVP,
    ResolverFactory
) {
    'use strict';

    var pathUtil;
    var rf = new ResolverFactory();

    pathUtil = rf.produce();

    return pathUtil;
});

